<template>
  <div class="flex flex-col bg-[#f8fafc] gap-4">

    <!-- Approval List Card -->
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 border-t-4 border-t-[#0d4169] flex flex-col">
      <div class="px-6 pt-5 pb-0 flex flex-col gap-4 border-b border-slate-100">
  <h2 class="text-base font-bold text-[#0d4169] text-left m-0">Approvals</h2>
  <div class="flex gap-6 -mb-[1px]">
    <button
      v-if="canSeeStoreTab"
      @click="activeTab = 'store'" 
      :class="{'border-[#0d4169] text-[#0d4169]': activeTab === 'store', 'border-transparent text-slate-500': activeTab !== 'store'}" 
      class="pb-2 text-sm font-bold border-b-2 hover:text-[#0d4169] transition-colors">
      Store Requests
      <span
        v-if="storeCount > 0"
        class="ml-2 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full bg-rose-500 text-white text-[10px] font-extrabold"
      >
        {{ storeCount }}
      </span>
    </button>
    <button
      v-if="canSeeReturnsTab"
      @click="activeTab = 'returns'" 
      :class="{'border-[#0d4169] text-[#0d4169]': activeTab === 'returns', 'border-transparent text-slate-500': activeTab !== 'returns'}" 
      class="pb-2 text-sm font-bold border-b-2 hover:text-[#0d4169] transition-colors">
      Returns
      <span
        v-if="returnsCount > 0"
        class="ml-2 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full bg-rose-500 text-white text-[10px] font-extrabold"
      >
        {{ returnsCount }}
      </span>
    </button>
    <button
      v-if="canSeePrsTab"
      @click="activeTab = 'prs'" 
      :class="{'border-[#0d4169] text-[#0d4169]': activeTab === 'prs', 'border-transparent text-slate-500': activeTab !== 'prs'}" 
      class="pb-2 text-sm font-bold border-b-2 hover:text-[#0d4169] transition-colors">
      Purchase Requisitions
      <span
        v-if="prsCount > 0"
        class="ml-2 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full bg-rose-500 text-white text-[10px] font-extrabold"
      >
        {{ prsCount }}
      </span>
    </button>
  </div>
</div>

      <!-- Approval Table -->
      <div v-show="activeTab === 'store' && canSeeStoreTab">
  <div v-if="srList.length > 0" class="px-2 pt-4 pb-6">
        <div class="max-h-[500px] overflow-x-auto overflow-y-auto border rounded">

  <table class="min-w-max w-full border-collapse bg-white">

    <thead class="bg-white">
      <tr>
        <th class="sticky top-0 bg-white z-10">No.</th>

        <th @click="sortBy('transactionDate')" class="sort-col sticky top-0 bg-white z-10">
          Req. Date
          <span v-if="sortKey === 'transactionDate'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        </th>

        <th @click="sortBy('department')" class="sort-col sticky top-0 bg-white z-10">
          Req.Department
          <span v-if="sortKey === 'department'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        </th>

        <th @click="sortBy('requester')" class="sort-col sticky top-0 bg-white z-10">
          Req. name
          <span v-if="sortKey === 'requester'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        </th>

        <th @click="sortBy('srNumber')" class="sort-col sticky top-0 bg-white z-10">
          Req. number
          <span v-if="sortKey === 'srNumber'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        </th>

        <th @click="sortBy('category')" class="sort-col sticky top-0 bg-white z-10">
          Category
          <span v-if="sortKey === 'category'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        </th>

        <th @click="sortBy('item')" class="sort-col sticky top-0 bg-white z-10">
          Item
          <span v-if="sortKey === 'item'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        </th>

        <th @click="sortBy('uom')" class="sort-col sticky top-0 bg-white z-10">
          U.O.M
          <span v-if="sortKey === 'uom'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        </th>

        <th @click="sortBy('requestedQuantity')" class="sort-col sticky top-0 bg-white z-10">
          Req. Qty
          <span v-if="sortKey === 'requestedQuantity'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        </th>

        <th @click="sortBy('approvedQuantity')" class="sort-col sticky top-0 bg-white z-10">
          Appr. Qty
          <span v-if="sortKey === 'approvedQuantity'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        </th>

        <th class="sticky top-0 bg-white z-10">
          Action
        </th>

        <th @click="sortBy('balance')" class="sort-col sticky top-0 bg-white z-10">
          Balance
          <span v-if="sortKey === 'balance'">{{ sortOrder === 'asc' ? '↑' : '↓' }}</span>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(sr, index) in sortedSrs" :key="sr.srNumber + index" class="hover:bg-slate-100/50 transition-colors border-b">
        <td>{{ index + 1 }}</td>
        <td>{{ formatDateDdMmYyyy(sr.transactionDate) }}</td>
        <td>{{ sr.department }}</td>
        <td>{{ sr.requester || '-' }}</td>
        <td>{{ sr.srNumber }}</td>
        <td>{{ sr.category }}</td>
        <td :class="isStoreRequestProduct(sr) ? 'text-emerald-600 font-semibold' : ''">{{ sr.item }}</td>
        <td>{{ sr.uom || '-' }}</td>
        <td>{{ sr.requestedQuantity.toFixed(2) }}</td>

        <td>
          <button @click="openQuantityModal(sr)" class="px-2 py-1 bg-slate-100 rounded text-sm border">
            {{ sr.approvedQuantity }}
          </button>
        </td>

        <td>
          <div class="flex items-center gap-1">
            <button
              type="button"
              @click="approveSr(sr, sr.srNumber)"
              class="px-3 py-1 bg-emerald-500 text-white text-[10px] font-bold rounded-lg hover:bg-emerald-600 transition-all shadow-sm active:scale-95"
            >
              Accept
            </button>

            <button
              type="button"
              @click="rejectSr(sr, sr.srNumber)"
              class="px-3 py-1 bg-red-500 text-white text-[10px] font-bold rounded-lg hover:bg-red-600 transition-all shadow-sm active:scale-95"
            >
              Reject
            </button>
          </div>
        </td>

        <td class="font-bold text-[#0d4169]">
          {{ sr.balance }}
        </td>
      </tr>
    </tbody>

  </table>

</div>
      </div>

        <div v-if="srList.length === 0" class="px-6 py-6 text-sm text-slate-500">
    No store requests available for approval.
  </div>
</div>
<!-- RETURNS TAB -->
<div v-show="activeTab === 'returns' && canSeeReturnsTab">
  <div v-if="pendingReturns.length > 0" class="px-6 py-4">
    <div class="w-full overflow-x-auto shadow-sm rounded-xl border border-slate-200 bg-white">
        <table class="min-w-max w-full border-collapse bg-white text-[0.65rem]">

          <thead class="bg-white">
            <tr>
              <th class="sticky top-0 bg-white z-10">#</th>
              <th @click="togglePendingSort('returnNo')" class="sticky top-0 bg-white z-10 sort-col">
                R No
                <span v-if="pendingSortKey === 'returnNo'">{{ pendingSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePendingSort('date')" class="sticky top-0 bg-white z-10 sort-col">
                Date
                <span v-if="pendingSortKey === 'date'">{{ pendingSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePendingSort('department')" class="sticky top-0 bg-white z-10 sort-col">
                Department
                <span v-if="pendingSortKey === 'department'">{{ pendingSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePendingSort('createdBy')" class="sticky top-0 bg-white z-10 sort-col">
                Returned By
                <span v-if="pendingSortKey === 'createdBy'">{{ pendingSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePendingSort('category')" class="sticky top-0 bg-white z-10 sort-col">
                Category
                <span v-if="pendingSortKey === 'category'">{{ pendingSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePendingSort('item')" class="sticky top-0 bg-white z-10 sort-col">
                Item
                <span v-if="pendingSortKey === 'item'">{{ pendingSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePendingSort('quantity')" class="sticky top-0 bg-white z-10 sort-col text-right">
                Qty
                <span v-if="pendingSortKey === 'quantity'">{{ pendingSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePendingSort('unitPrice')" class="sticky top-0 bg-white z-10 sort-col text-right">
                Unit Price
                <span v-if="pendingSortKey === 'unitPrice'">{{ pendingSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th  class="sticky top-0 bg-white z-10 sort-col text-right">
                Volume
                <!-- <span v-if="pendingSortKey === 'unitPrice'">{{ pendingSortOrder === 'asc' ? '↑' : '↓' }}</span> -->
              </th>
              <th @click="togglePendingSort('totalPrice')" class="sticky top-0 bg-white z-10 sort-col text-right">
                Total Cost
                <span v-if="pendingSortKey === 'totalPrice'">{{ pendingSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th class="sticky top-0 bg-white z-10">Reason</th>
              <th class="sticky top-0 bg-white z-10 text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(ret, retIndex) in sortedPendingReturns" :key="ret.id">
              <tr
                v-for="(item) in (ret.items || []).filter(x => Number(x?.isApproved || 0) === 0)"
                :key="item.id"
                class="hover:bg-slate-100/50 transition-colors border-b"
              >
                <td>{{ retIndex + 1 }}</td>
                <td>
                  <span>{{ ret.returnNo }}</span>
                </td>
                <td>
                  <span >{{ formatDateDdMmYyyy(ret.date) }}</span>
                </td>
                <td>
                  <span >{{ ret.department?.name || '-' }}</span>
                </td>
                <td>
                  <span >{{ ret.creator?.full_name || ret.creator?.username || '-' }}</span>
                </td>
                <td>{{ item.item?.category?.name || '-' }}</td>
                <td>{{ item.item?.itemName }}</td>
                <td class="text-right font-semibold">{{ item.quantity.toFixed(2) }}</td>
                <td class="text-right">{{ item.unitPrice?.toLocaleString() || '-' }}</td>
                <td class="text-right">{{ item.variantDetails }}</td>
                <td class="text-right text-indigo-600 font-bold">{{ (item.totalPrice || 0).toLocaleString() }}</td>
                <td class="text-slate-500 italic">{{ item.remark || '-' }}</td>
                <td class="text-center">
                  <div  class="flex items-center justify-center gap-2">
                    <button @click="handleReturnApproval(item.id, 1)" 
                      class="px-3 py-1 bg-emerald-500 text-white text-[10px] font-bold rounded-lg hover:bg-emerald-600 transition-all shadow-sm active:scale-95">Accept</button>
                    <button @click="handleReturnApproval(item.id, 2)" 
                      class="px-3 py-1 bg-red-500 text-white text-[10px] font-bold rounded-lg hover:bg-red-600 transition-all shadow-sm active:scale-95">Reject</button>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
  </div>
  <div v-else class="px-6 py-6 text-sm text-slate-500">
    No returns available for approval.
  </div>
</div>
<!-- PRS TAB -->
<div v-show="activeTab === 'prs' && canSeePrsTab">
  <div v-if="pendingPrs.length > 0" class="px-6 py-4">
    <div class="w-full overflow-x-auto shadow-sm rounded-xl border border-slate-200 bg-white">
        <table class="min-w-max w-full border-collapse bg-white text-[0.65rem]">
          <thead class="bg-white">
            <tr>
              <th class="sticky top-0 bg-white z-10">#</th>
              <th @click="togglePrSort('prNo')" class="sticky top-0 bg-white z-10 sort-col">
                PR No
                <span v-if="prSortKey === 'prNo'">{{ prSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePrSort('date')" class="sticky top-0 bg-white z-10 sort-col">
                Date
                <span v-if="prSortKey === 'date'">{{ prSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePrSort('department')" class="sticky top-0 bg-white z-10 sort-col">
                Department
                <span v-if="prSortKey === 'department'">{{ prSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePrSort('requestedBy')" class="sticky top-0 bg-white z-10 sort-col">
                Requested By
                <span v-if="prSortKey === 'requestedBy'">{{ prSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePrSort('category')" class="sticky top-0 bg-white z-10 sort-col">
                Category
                <span v-if="prSortKey === 'category'">{{ prSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th @click="togglePrSort('item')" class="sticky top-0 bg-white z-10 sort-col">
                Item
                <span v-if="prSortKey === 'item'">{{ prSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th class="sticky top-0 bg-white z-10">Unit</th>
              <th @click="togglePrSort('quantity')" class="sticky top-0 bg-white z-10 sort-col text-center">
                Req. Qty
                <span v-if="prSortKey === 'quantity'">{{ prSortOrder === 'asc' ? '↑' : '↓' }}</span>
              </th>
              <th class="sticky top-0 bg-white z-10 text-center">Appr. Qty</th>
              <th class="sticky top-0 bg-white z-10 text-center">U. Price</th>
              <th class="sticky top-0 bg-white z-10 text-center">T. Price</th>
              <th class="sticky top-0 bg-white z-10 text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(pr, prIndex) in sortedPendingPrs" :key="pr.id">
              <tr v-for="(item, itemIndex) in (pr.items || []).filter(x => Number(x?.isApproved || 0) === 0)" :key="item.id" class="hover:bg-slate-100/50 transition-colors border-b">
                <td>{{ sortedPendingPrs.slice(0, prIndex).reduce((sum, prevPr) => sum + ((prevPr.items || []).filter(x => Number(x?.isApproved || 0) === 0).length || 0), 0) + itemIndex + 1 }}</td>
                <td>{{ pr.prNo || '-' }}</td>
                <td>{{ formatDateDdMmYyyy(pr.date) }}</td>
                <td>{{ getPrDepartmentDisplay(pr) }}</td>
                <td>{{ pr.creator?.full_name || pr.creator?.username || '-' }}</td>
                <td>{{ item.item?.category?.name || '-' }}</td>
                <td>{{ item.item?.itemName }}</td>
                <td>{{ item.item?.unit || '-' }}</td>
                <td class="text-center font-semibold">{{ Number(item.quantity || 0).toFixed(2) }}</td>
                <td class="text-center">
                  <button
                    type="button"
                    @click="openPrQuantityModal(pr, item)"
                    class="px-2 py-1 bg-slate-100 rounded text-sm border"
                  >
                    {{ Number(item.approvedQty ?? item.approved_qty ?? item.quantity ?? 0).toFixed(2) }}
                  </button>
                </td>
                <td class="text-center">{{ (Number(item.unitPrice ?? item.unit_price ?? 0)).toFixed(2) }}</td>
                <td class="text-center text-indigo-600 font-bold">
                  {{
                    (
                      Number(item.unitPrice ?? item.unit_price ?? 0) *
                      Number(item.approvedQty ?? item.approved_qty ?? item.quantity ?? 0)
                    ).toFixed(2)
                  }}
                </td>
                <td class="text-center">
                  <div class="flex items-center justify-center gap-2">
                    <button @click="handlePrItemApproval(item.id, 1)" 
                      class="px-3 py-1 bg-emerald-500 text-white text-[10px] font-bold rounded-lg hover:bg-emerald-600 transition-all shadow-sm active:scale-95">Accept</button>
                    <button @click="handlePrItemApproval(item.id, 2)" 
                      class="px-3 py-1 bg-red-500 text-white text-[10px] font-bold rounded-lg hover:bg-red-600 transition-all shadow-sm active:scale-95">Reject</button>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
  </div>
  <div v-else class="px-6 py-6 text-sm text-slate-500">
    No purchase requisitions available for approval.
  </div>
</div>

    </div>

  </div>
  <!-- Quantity Edit Modal -->
  <div v-if="showQtyModal" class="fixed inset-0 z-[200] flex items-start justify-center px-4 py-8 overflow-y-auto bg-black/50 backdrop-blur-sm" @click.self="showQtyModal = false">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-md transform transition-all animate-in fade-in zoom-in duration-300 text-left relative overflow-visible">
      <!-- Modal Header -->
      <div class="px-6 py-4 bg-[#0d4169] text-white flex items-center justify-between rounded-t-xl">
        <h2 class="text-lg font-bold m-0">Edit Approved Quantity</h2>
        <button @click="showQtyModal = false" class="p-1 hover:bg-white/10 rounded-full transition-colors text-white">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>

      <!-- Modal Body -->
      <form @submit.prevent="saveQuantity" class="p-8">
        <div class="flex flex-col gap-4">
          <div class="flex flex-col gap-1.5">
            <label class="text-[0.85rem] font-semibold text-[#1e293b]">Item Name</label>
            <input :value="modalItemName" type="text" class="px-3 py-2 border border-[#cbd5e1] rounded-md bg-slate-50 text-slate-500 text-sm outline-none" readonly />
          </div>

          <div class="flex flex-col gap-1.5">
            <label class="text-[0.85rem] font-semibold text-[#1e293b]">Approved Quantity</label>
            <input 
              v-model.number="modalQuantity" 
              type="number" 
              step="0.01" 
              placeholder="0.00"
              class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
              required 
            />
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="mt-8 pt-6 border-t border-slate-100 flex items-center justify-end gap-3">
          <button 
            type="button" 
            @click="showQtyModal = false" 
            class="px-4 py-2 text-sm font-semibold text-slate-500 hover:text-slate-800 transition-colors"
          >
            Cancel
          </button>
          <button 
            type="submit" 
            class="px-6 py-2 bg-[#0d4169] text-white text-sm font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:transform active:scale-95 whitespace-nowrap"
          >
            Save Quantity
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- PR Approved Quantity Edit Modal -->
  <div v-if="showPrQtyModal" class="fixed inset-0 z-[200] flex items-start justify-center px-4 py-8 overflow-y-auto bg-black/50 backdrop-blur-sm" @click.self="showPrQtyModal = false">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-md transform transition-all animate-in fade-in zoom-in duration-300 text-left relative overflow-visible">
      <div class="px-6 py-4 bg-[#0d4169] text-white flex items-center justify-between rounded-t-xl">
        <h2 class="text-lg font-bold m-0">Edit Approved Quantity</h2>
        <button @click="showPrQtyModal = false" class="p-1 hover:bg-white/10 rounded-full transition-colors text-white">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>

      <form @submit.prevent="savePrApprovedQty" class="p-8">
        <div class="flex flex-col gap-4">
          <div class="flex flex-col gap-1.5">
            <label class="text-[0.85rem] font-semibold text-[#1e293b]">Item Name</label>
            <input :value="prModalItemName" type="text" class="px-3 py-2 border border-[#cbd5e1] rounded-md bg-slate-50 text-slate-500 text-sm outline-none" readonly />
          </div>

          <div class="flex flex-col gap-1.5">
            <label class="text-[0.85rem] font-semibold text-[#1e293b]">Approved Quantity</label>
            <input
              v-model.number="prModalApprovedQty"
              type="number"
              step="0.01"
              min="0"
              placeholder="0.00"
              class="px-3 py-2 border border-[#cbd5e1] rounded-md outline-none focus:border-[#2563eb] transition-all text-sm"
              required
            />
          </div>
        </div>

        <div class="mt-8 pt-6 border-t border-slate-100 flex items-center justify-end gap-3">
          <button type="button" @click="showPrQtyModal = false" class="px-4 py-2 text-sm font-semibold text-slate-500 hover:text-slate-800 transition-colors">
            Cancel
          </button>
          <button type="submit" class="px-6 py-2 bg-[#0d4169] text-white text-sm font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:transform active:scale-95 whitespace-nowrap">
            Save Quantity
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import store from '../../store'
import { apiFetch } from '../../utils/api'



const srList = ref([])
// Sorting is fixed: created_at asc (oldest at top)
const sortKey = ref(null)
const sortOrder = ref('asc')
const loading = ref(false)

const route = useRoute()
const activeTab = ref(route.query.tab || 'store')
watch(() => route.query.tab, (newTab) => {
  if (newTab) activeTab.value = newTab
  syncActiveTabToAllowed()
})

const pendingReturns = ref([])
// Sorting is fixed: created_at asc (oldest at top)
const pendingSortKey = ref(null)
const pendingSortOrder = ref('asc')

const pendingPrs = ref([])
// Sorting is fixed: created_at asc (oldest at top)
const prSortKey = ref(null)
const prSortOrder = ref('asc')
const currentUser = computed(() => store.getters.currentUser || {})
const companyId = computed(() => currentUser.value?.companyId || currentUser.value?.company_id || currentUser.value?.company?.id || null)
const branchId = computed(() => currentUser.value?.branchId || currentUser.value?.branch_id || currentUser.value?.branch?.id || null)

const userPrivileges = computed(() => {
  const raw = currentUser.value?.privilege
  if (!raw) return {}
  try {
    return typeof raw === 'string' ? JSON.parse(raw) : raw
  } catch {
    return {}
  }
})
const hasAdminPrivilege = computed(() => userPrivileges.value?.All === true || userPrivileges.value?.all === true)

function getPrivilegeBlock(name) {
  return userPrivileges.value?.[name] || userPrivileges.value?.[String(name).toLowerCase()] || null
}

const canSeeStoreTab = computed(() =>
  hasAdminPrivilege.value || !!getPrivilegeBlock('Store Request')?.Approve
)
const canSeeReturnsTab = computed(() =>
  hasAdminPrivilege.value || !!getPrivilegeBlock('Return')?.Approve
)
const canSeePrsTab = computed(() =>
  hasAdminPrivilege.value || !!getPrivilegeBlock('Purchase Request')?.Approve
)

function syncActiveTabToAllowed() {
  const allowed = {
    store: canSeeStoreTab.value,
    returns: canSeeReturnsTab.value,
    prs: canSeePrsTab.value,
  }
  if (allowed[activeTab.value]) return
  if (allowed.store) activeTab.value = 'store'
  else if (allowed.returns) activeTab.value = 'returns'
  else if (allowed.prs) activeTab.value = 'prs'
}

watch(
  [canSeeStoreTab, canSeeReturnsTab, canSeePrsTab],
  () => {
    syncActiveTabToAllowed()
  },
  { immediate: true }
)

function toTimeMs(v) {
  if (!v) return 0
  const d = new Date(v)
  const t = d.getTime()
  return Number.isFinite(t) ? t : 0
}

function formatDateDdMmYyyy(value) {
  const raw = String(value || '').trim()
  if (!raw) return '-'
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`
  const d = new Date(value)
  if (!Number.isFinite(d.getTime())) return raw
  const dd = String(d.getDate()).padStart(2, '0')
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const yyyy = d.getFullYear()
  return `${dd}/${mm}/${yyyy}`
}

function getCreatedMs(obj) {
  // Prefer created_at/createdAt when available (includes hh:mm:ss)
  return (
    toTimeMs(obj?.created_at) ||
    toTimeMs(obj?.createdAt) ||
    toTimeMs(obj?.updated_at) ||
    toTimeMs(obj?.updatedAt) ||
    toTimeMs(obj?.date) ||
    toTimeMs(obj?.transactionDate) ||
    0
  )
}

const sortedPendingReturns = computed(() => {
  const data = [...pendingReturns.value]
  data.sort((a, b) => getCreatedMs(a) - getCreatedMs(b))

  return data
})

const sortedPendingPrs = computed(() => {
  const data = [...pendingPrs.value]
  data.sort((a, b) => getCreatedMs(a) - getCreatedMs(b))

  return data
})

function getPrDepartmentDisplay(pr) {
  const departmentName = pr?.department?.name
  if (departmentName) return departmentName
  const remark = String(pr?.remark || '').trim()
  if (remark.toLowerCase() === 'stock') return 'Stock'
  return '-'
}

async function fetchPendingReturns() {
  const user = store.getters.currentUser || {};
  const companyId = user.companyId || user.company_id || null;
  const branchId = user.branchId || user.branch_id || null;
  if (!companyId && !branchId) return
  try {
    const query = branchId ? `branchId=${branchId}` : `companyId=${companyId}`;
    const res = await apiFetch(`/return?${query}&isApproved=0`)
    if (res.ok) {
      pendingReturns.value = await res.json()
    }
  } catch (err) { console.error(err) }
}

function togglePendingSort() {
  // Sorting is fixed by created_at asc; disable interactive sort
  return
}

async function handleReturnApproval(id, status) {
  if (!confirm(status==1?"Are you sure..........Approve?":"Are you sure..........Reject?")) return
  try {
    // Approve/reject a single ReturnItem row (child), not the whole parent Return.
    const res = await apiFetch(`/return/items/${id}/approval`, {
      method: 'PATCH',
      body: JSON.stringify({ isApproved: status })
    })
    if (res.ok) {
      fetchPendingReturns()
    } else {
      const err = await res.json()
      alert('Error: ' + err.message)
    }
  } catch (err) { console.error(err) }
}

async function fetchPendingPrs() {
  const user = store.getters.currentUser || {};
  const companyId = user.companyId || user.company_id || null;
  const branchId = user.branchId || user.branch_id || null;
  if (!companyId && !branchId) return
  try {
    const query = branchId ? `branchId=${branchId}` : `companyId=${companyId}`;
    const res = await apiFetch(`/purchase-requisition?${query}&isApproved=0`)
    if (res.ok) {
      pendingPrs.value = await res.json()
    }
  } catch (err) { console.error(err) }
}

function togglePrSort() {
  // Sorting is fixed by created_at asc; disable interactive sort
  return
}

async function handlePrItemApproval(itemId, status) {
  if (!confirm(status==1?"Are you sure..........Approve?":"Are you sure..........Reject?")) return
  try {
    const res = await apiFetch(`/purchase-requisition/items/${itemId}/approval`, {
      method: 'PATCH',
      body: JSON.stringify({ isApproved: status })
    })
    if (res.ok) {
      fetchPendingPrs()
    } else {
      const err = await res.json().catch(() => ({}))
      alert('Error: ' + (err?.message || 'Failed to update item'))
    }
  } catch (err) { console.error(err) }
}


async function loadSrList() {
  try {
    loading.value = true
    const response = await apiFetch('/store-request/pending')
    if (!response.ok) {
      console.error('Failed to load pending requests:', response.statusText)
      return
    }
    const data = await response.json()
    srList.value = data.data || []
    await loadCurrentBalancesForStoreRequests()
  } catch (error) {
    console.error('Error loading pending store requests:', error)
  } finally {
    loading.value = false
  }
}

// Match itemPage.vue logic: fetch item + product stock-balance summaries.
async function loadCurrentBalancesForStoreRequests() {
  const params = new URLSearchParams()
  if (branchId.value) params.append('branchId', branchId.value)
  else if (companyId.value) params.append('companyId', companyId.value)
  const query = params.toString()

  try {
    const [itemRes, productRes] = await Promise.all([
      apiFetch(`/items/stock-balance-summary?${query}`),
      apiFetch(`/products/stock-balance-summary?${query}`),
    ])
    const itemSummary = itemRes.ok ? await itemRes.json().catch(() => []) : []
    const productSummary = productRes.ok ? await productRes.json().catch(() => []) : []
    const itemMap = new Map(
      (Array.isArray(itemSummary) ? itemSummary : []).map((r) => [Number(r.id), Number(r.current_balance || 0)])
    )
    const productMap = new Map(
      (Array.isArray(productSummary) ? productSummary : []).map((r) => [Number(r.id), Number(r.current_balance || 0)])
    )

    srList.value = (Array.isArray(srList.value) ? srList.value : []).map((sr) => {
      if (isStoreRequestProduct(sr)) {
        const productId = Number(sr.productId ?? sr.product_id ?? null)
        const balance = Number.isFinite(productId) && productId > 0
          ? Math.round((productMap.get(productId) || 0) * 100) / 100
          : 0
        return { ...sr, balance }
      }
      const itemId = Number(sr.itemId ?? sr.item_id ?? null)
      const balance = Number.isFinite(itemId) && itemId > 0
        ? Math.round((itemMap.get(itemId) || 0) * 100) / 100
        : 0
      return { ...sr, balance }
    })
  } catch (err) {
    console.error('Failed to load stock balance summaries for approvals', err)
    srList.value = (Array.isArray(srList.value) ? srList.value : []).map((sr) => ({ ...sr, balance: 0 }))
  }
}

function isStoreRequestProduct(sr) {
  if (!sr) return false
  if (String(sr.itemType || '').toLowerCase() === 'product') return true
  const productId = Number(sr.productId ?? sr.product_id ?? null)
  return Number.isFinite(productId) && productId > 0
}

function sortBy() {
  // Sorting is fixed by created_at asc; disable interactive sort
  return
}

const sortedSrs = computed(() => {
  // Only show Pending requests
  const result = srList.value.filter(sr => !sr.status || sr.status === 'Pending')
  // Store Requests: sort by Req. number ASC (per requirement),
  // then by created time ASC as tie-breaker.
  result.sort((a, b) => {
    const aNo = String(a.srNumber || a.reqNo || a.requestNo || '')
    const bNo = String(b.srNumber || b.reqNo || b.requestNo || '')
    const cmp = aNo.localeCompare(bNo, undefined, { numeric: true, sensitivity: 'base' })
    if (cmp !== 0) return cmp
    return getCreatedMs(a) - getCreatedMs(b)
  })
  return result
})

const storeCount = computed(() => sortedSrs.value.length)
const returnsCount = computed(() => pendingReturns.value.length)
const prsCount = computed(() => pendingPrs.value.length)

async function approveSr(sr) {
  if (!confirm("Are you sure..........Approve?")) return
  try {
    loading.value = true
    const response = await apiFetch(`/store-request/${sr.requestId}/approve`, {
      method: 'POST',
      body: JSON.stringify({ itemIds: [sr.id] })
    })
    if (!response.ok) {
      console.error('Failed to approve store request:', response.statusText)
      return
    }
    await loadSrList()
  } catch (error) {
    console.error('Error approving store request:', error)
  } finally {
    loading.value = false
  }
}

async function rejectSr(sr) {
  const reason = prompt('Enter rejection reason:')
  if (!reason) return
  if (!confirm("Are you sure..........Reject?")) return

  try {
    loading.value = true
    const response = await apiFetch(`/store-request/${sr.requestId}/reject`, {
      method: 'POST',
      body: JSON.stringify({ itemIds: [sr.id], remark: reason })
    })
    if (!response.ok) {
      console.error('Failed to reject store request:', response.statusText)
      return
    }
    await loadSrList()
  } catch (error) {
    console.error('Error rejecting store request:', error)
  } finally {
    loading.value = false
  }
}

// Quantity modal state and handlers
const showQtyModal = ref(false)
const modalItemName = ref('')
const modalQuantity = ref(0)
const modalItemId = ref(null)

function openQuantityModal(sr) {
  modalItemName.value = sr.item || ''
  modalQuantity.value = sr.approvedQuantity ?? sr.quantity ?? 0
  modalItemId.value = sr.id
  showQtyModal.value = true
}

async function saveQuantity() {
  if (!modalItemId.value) return
  try {
    loading.value = true
    const response = await apiFetch(`/store-request/items/${modalItemId.value}`, {
      method: 'PATCH',
      body: JSON.stringify({ quantity: modalQuantity.value })
    })
    if (!response.ok) {
      console.error('Failed to update quantity:', response.statusText)
      return
    }
    showQtyModal.value = false
    await loadSrList()
  } catch (error) {
    console.error('Error updating quantity:', error)
  } finally {
    loading.value = false
  }
}

// PR approved quantity modal state and handlers
const showPrQtyModal = ref(false)
const prModalItemName = ref('')
const prModalApprovedQty = ref(0)
const prModalItemId = ref(null)

function openPrQuantityModal(pr, item) {
  prModalItemName.value = item?.item?.itemName || '-'
  prModalApprovedQty.value = Number(item?.approvedQty ?? item?.approved_qty ?? item?.quantity ?? 0)
  prModalItemId.value = item?.id || null
  showPrQtyModal.value = true
}

async function savePrApprovedQty() {
  if (!prModalItemId.value) return
  try {
    const qty = Number(prModalApprovedQty.value)
    if (!Number.isFinite(qty) || qty < 0) {
      alert('Invalid approved quantity')
      return
    }

    loading.value = true
    const res = await apiFetch(`/purchase-requisition/items/${prModalItemId.value}/approved-qty`, {
      method: 'PATCH',
      body: JSON.stringify({ approvedQty: qty })
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      alert(err?.message || 'Failed to update approved quantity')
      return
    }
    showPrQtyModal.value = false
    await fetchPendingPrs()
  } catch (err) {
    console.error('Failed to update PR approved qty:', err)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  loadSrList()
  fetchPendingReturns()
  fetchPendingPrs()
})
setInterval(() => {
  loadSrList()
  fetchPendingReturns()
  fetchPendingPrs()
}, 40000);
</script>

<style scoped>
table {
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.82rem;
  color: #1e293b;
}

thead th {
  position: sticky;
  top: 0;
  z-index: 50;
  background: #f1f5f9;
}

th,
td {
  padding: 5px 6px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.72rem;
  white-space: nowrap;
}

th {
  background: #f1f5f9;
  cursor: default;
  font-weight: 600;
}

th.sort-col {
  cursor: pointer;
}
th.sort-col:hover {
  background: #e2e8f0;
}

tbody tr:hover {
  background: #f8fafc;
}

.status-pill {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 600;
}
.status-pill.pending {
  background: #e0f2fe;
  color: #075985;
}

.status-pill.approved {
  background: #dcfce7;
  color: #166534;
}

.status-pill.rejected {
  background: #fee2e2;
  color: #b91c1c;
}

.animate-in {
  animation: 0.2s ease-out forwards;
}
.fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
.zoom-in {
  from { transform: scale(0.95); }
  to { transform: scale(1); }
}
</style>

